import Input from '@atoms/Input';
import MaxLengthCounter from '@components/Presentation/atoms/MaxLengthCounter';
import { calculateRemainingChars } from '@components/Presentation/helpers';
import { useRef, useState } from 'react';

interface TextLimiterInputProps {
  value: string;
  setValue: (value: string) => void;
  limit: number;
  defaultValue?: string;
  placeholder?: string;
}
const TextLimiterInput = ({ value, setValue, limit, defaultValue, placeholder }: TextLimiterInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  return <div>
    <Input
      ref={inputRef}
      placeholder={placeholder || 'Enter text'}
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => setValue(e.target.value)}
      size="lg"
      maxLength={limit}
      handleFocus={setIsFocused}
      addOnRight={
        isFocused ? (
          <MaxLengthCounter
            value={calculateRemainingChars(value, limit)}
          />
        ) : null
      }
    />
    {calculateRemainingChars(value, limit) === 0 && (
      <p className="text-sm text-alert mt-1">
        You have reached the maximum length
      </p>
    )}
  </div>;
};

export default TextLimiterInput;
